import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import LoadingPage from 'components/common/LoadingPage';
import useUser from 'hooks/useUser';

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const { hasFetchedUserInfo, isDropShipUser } = useUser();

  if (!hasFetchedUserInfo) {
    return <LoadingPage />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isDropShipUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
